import { takeLatest, call, put } from 'redux-saga/effects';

import { actions as snackbarActions } from 'redux/snackbar';
import * as api from 'http/admin/job-status';

import { actions } from './index';

export function* getJobStatus({ payload }) {
  try {
    const { tenantId } = payload;

    const result = yield call(api.getJobStatus, { tenantId });

    yield put(actions.getJobStatusSuccess(result));
  } catch (error) {
    yield put(actions.getJobStatusFailure(error));
    yield put(snackbarActions.showSnackbar({ data: { type: 'error', message: error.message } }));
  }
}

export default function* sagas() {
  yield takeLatest(actions.getJobStatus, getJobStatus);
}
